module.exports = __webpack_public_path__ + "img/Metastasis-PRCA_SpatialResearch.05046c0e.png";